import type { TxStatus } from '@apm/contracts';
import { type StatusInput, type StatusLevel, statusLevel } from '@apm/core';

/**
 * 끝난 요청의 상태 표시 (6회차 보완 결정 2, 7회차 결정 5).
 *
 * 판정은 `@apm/core`의 `statusLevel` 하나만 쓴다. 화면·검색·알림이 같은 규칙을 봐야
 * 같은 요청이 화면에서는 '실패', 검색에서는 '정상'으로 갈리지 않는다(13회차).
 * 여기 남은 것은 화면 전용 문구와 색뿐이다.
 */

export type { StatusInput, StatusLevel };
export { statusLevel };

const STATUS_LEVEL_LABEL: Record<StatusLevel, string> = {
  ok: '정상',
  fail: '실패',
  error: '오류',
};

/** 5xx가 아닌 종료 사유는 단계 이름 대신 제 이름을 보인다 */
const TX_STATUS_LABEL: Record<TxStatus, string> = {
  ok: '정상',
  error: '오류',
  timeout: '시간초과',
  cancelled: '취소',
};

/** 화면 문구. 예: `실패 (403)`, `오류 (500)`, `시간초과` */
export function statusText(row: StatusInput): string {
  const label =
    row.status === 'ok' ? STATUS_LEVEL_LABEL[statusLevel(row)] : TX_STATUS_LABEL[row.status];
  return row.httpStatus === undefined ? label : `${label} (${row.httpStatus})`;
}

/** 실패는 주황, 오류는 빨강. 캔버스 점 색(theme.ts STATUS)과 같은 색이다 */
export const STATUS_LEVEL_TEXT: Record<StatusLevel, string> = {
  ok: 'text-ink',
  fail: 'text-fail',
  error: 'text-error',
};

export const STATUS_LEVEL_CHIP: Record<StatusLevel, string> = {
  ok: 'bg-ok/10 text-ok ring-1 ring-inset ring-ok/25',
  fail: 'bg-fail/10 text-fail ring-1 ring-inset ring-fail/25',
  error: 'bg-error/10 text-error ring-1 ring-inset ring-error/25',
};
